import React, { useEffect, useMemo, useState } from "react"
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  TextField,
} from "@mui/material"

const TagsObsModalContent = ({ tags, modalData, rowsSelected, onSave }) => {
  const [selectedTag, setSelectedTag] = useState({ id: null, title: "" })
  const [comment, setComment] = useState("")

  const handleSetInitialFormData = () => {
    const filteredRow = rowsSelected.find(row => row.id === modalData.id)

    if (filteredRow) {
      setSelectedTag({
        id: filteredRow.id,
        title: tags.find(tag => tag.id === filteredRow.tag)?.title,
      })
      setComment(filteredRow.observacao)
    }
  }

  useEffect(() => {
    handleSetInitialFormData()
  }, [modalData, rowsSelected])

  return (
    <div>
      <FormControl fullWidth>
        <InputLabel id="tag-select-label">Selecione uma Tag</InputLabel>
        <Select
          labelId="tag-select-label"
          size="small"
          id="tag-select"
          value={selectedTag.title}
          onChange={event => {
            const tagId = tags.find(tag => tag.title === event.target.value).id
            setSelectedTag({ id: tagId, title: event.target.value })
          }}
          label="Selecione uma Tag"
        >
          {tags.map(tag => (
            <MenuItem key={tag.id} value={tag.title}>
              {tag.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        label="Observação"
        multiline
        rows={4}
        fullWidth
        value={comment}
        onChange={event => setComment(event.target.value)}
        variant="outlined"
        margin="normal"
      />

      <div
        style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={() =>
            onSave({ id: modalData.id, tag: selectedTag.id, comment })
          }
        >
          Salvar
        </Button>
      </div>
    </div>
  )
}

export default TagsObsModalContent
